import { useState, useEffect } from 'react';

export function useContactPicker() {
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    // Check for the existence of the contacts API on the navigator object
    if ('contacts' in navigator && navigator.contacts && 'select' in navigator.contacts) {
      setIsSupported(true);
    }
  }, []);

  return { isContactPickerSupported: isSupported };
}
